module.exports = __webpack_public_path__ + "img/2@s.d2d854b9.jpg";